import React from 'react';
import styles from './MapPoint.scss';

import cn from 'classnames';

const MapPoint = (props) => {
  const { contexuality, className, onClick } = props;
  return <span className={cn(styles.MapPoint, contexuality ? styles[contexuality] : null, className)} onClick={onClick} />;
};

export default MapPoint;



// WEBPACK FOOTER //
// ./src/components/common/MapPoint/MapPoint.js